import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CustomEventManager } from '../../utils/custom-event-manager';

import { AppUiModule } from '../../ui/app-ui.module';
import { SharedModule } from '../../shared/shared.module';
import { WorkShiftRoutingModule } from './work-shifts-routing.module';
import { WorkShiftsComponent } from './work-shifts/work-shifts.component';
import { WorkShiftsTableComponent } from './work-shifts/work-shifts-table/work-shifts-table.component';
import { WorkShiftsTemplateFilterComponent } from './work-shifts/work-shifts-template-filter/work-shifts-template-filter.component';
import { EventManager } from '@angular/platform-browser';
import { WorkShiftCellPopoverComponent } from './work-shifts/work-shifts-table/popovers/work-shift-cell-popover/work-shift-cell-popover.component';
import { WorkShiftsProgressComponent } from './work-shifts/work-shifts-table/work-shifts-progress/work-shifts-progress.component';
import { WorkShiftUserPopoverComponent } from './work-shifts/work-shifts-table/popovers/work-shift-user-popover/work-shift-user-popover.component';
import { WorkShiftsService } from './work-shifts.service';
import { WorkShiftsTemplateFilterService } from './work-shifts/work-shifts-template-filter/work-shifts-template-filter.service';
import { WorkShiftHoursPipe, WorkShiftHoursOnlyPipe } from './work-shifts/work-shifts-table/popovers/work-shift-cell-popover/work-shift-hours.pipe';
import { FixedPlanedScheduleModalComponent } from './work-shifts/modals/fixed-planed-schedule-modal/fixed-planed-schedule-modal.component';
import { WorkShiftRolePopoverComponent } from './work-shifts/work-shifts-table/popovers/work-shift-role-popover/work-shift-role-popover.component';
import { WorkShiftButtonWrapperComponent } from './work-shifts/work-shifts-table/popovers/work-shift-button-wrapper/work-shift-button-wrapper.component';
import { WorkShiftsDaysPipe } from './work-shifts/work-shifts-days.pipe';
import { ResourceDistributionComponent } from './work-shifts/resource-distribution/resource-distribution.component';
import { WorkRestrictionsRulesComponent } from './work-shifts/work-restrictions-rules/work-restrictions-rules.component';
import { CreateWorkRestrictionRuleModalComponent } from './work-shifts/work-restrictions-rules/modals/create-work-restriction-rule-modal/create-work-restriction-rule-modal.component';
import { RuleErrorModalComponent } from './work-shifts/work-restrictions-rules/modals/rule-error-modal/rule-error-modal.component';

@NgModule({
    declarations: [
        WorkShiftsComponent,
        WorkShiftsTableComponent,
        WorkShiftsTemplateFilterComponent,
        WorkShiftCellPopoverComponent,
        WorkShiftsProgressComponent,
        WorkShiftUserPopoverComponent,
        WorkShiftButtonWrapperComponent,
        WorkShiftHoursPipe,
        WorkShiftHoursOnlyPipe,
        FixedPlanedScheduleModalComponent,
        WorkShiftRolePopoverComponent,
        WorkShiftsDaysPipe,
        ResourceDistributionComponent,
        WorkRestrictionsRulesComponent,
        CreateWorkRestrictionRuleModalComponent,
        RuleErrorModalComponent,
    ],
    imports: [CommonModule, AppUiModule, SharedModule, WorkShiftRoutingModule, FormsModule, ReactiveFormsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [{ provide: EventManager, useClass: CustomEventManager }, WorkShiftsService, WorkShiftsTemplateFilterService]
})
export class WorkShiftsModule {}
